import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminRefundSettingsUpdateRequest {
  @jsonMember(Boolean)
  public readonly isCodEmailSent!: boolean;

  @jsonArrayMember(String)
  public readonly codMessageEmails!: string[];

  public constructor(
    private readonly data: {
      isCodEmailSent: boolean;
      codMessageEmails: string[];
    },
  ) {
    this.isCodEmailSent = this.data.isCodEmailSent;
    this.codMessageEmails = this.data.codMessageEmails;
  }
}
